import { SVGProps, Ref, forwardRef } from 'react';

export const MapPinFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.667 14.667C2.667 8 6 1.333 16 1.333S29.333 8 29.333 14.667c0 7.579-4.574 10.437-9.748 13.67-1.18.737-2.39 1.493-3.585 2.33-1.195-.837-2.406-1.593-3.585-2.33-5.174-3.233-9.748-6.091-9.748-13.67m10.4 0c0-.977.248-1.697.61-2.13.297-.357.9-.804 2.323-.804s2.025.447 2.323.803c.361.434.61 1.154.61 2.13 0 .977-.249 1.697-.61 2.13-.298.358-.9.804-2.323.804s-2.026-.446-2.323-.803c-.362-.434-.61-1.154-.61-2.13m-2.4 0C10.667 12 12 9.333 16 9.333s5.333 2.667 5.333 5.334S20 20 16 20s-5.334-2.667-5.334-5.333"
                fill="currentColor"
            />
        </g>
    </svg>
));
MapPinFilledSize32Glyph.displayName = 'MapPinFilledSize32Glyph';
